export enum FeedbackReason {
  JobFound = 'job_found',
  OfferReceived = 'offer_received',
  SearchPaused = 'search_paused',
  JobFoundSomewhereElse = 'job_found_somewhere_else',
  NotEffective = 'not_effective',
  TooDifficult = 'too_difficult',
  DontWantAccount = 'dont_want_account',
  Other = 'other',
}
